

.actionsMenuContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  height: 28px;
  width: 28px;

  &.disabled {
    pointer-events: none;
  }

  &::before {
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: height 0.25s ease-out, width 0.25s ease-out, background-color 0.25s ease-out;
    border-radius: 8px;
    @include themify($themes) {
      background-color: themed("main-secondary");
    }
  }

  &:not(.disabled):hover,
  &.taskActionsIsOpen {
    &::before {
      height: 28px;
      width: 28px;
      transition: height 0.25s ease-in, width 0.25s ease-in, background-color 0.25s ease-in;

      @include themify($themes) {
        background-color: themed("brand-secondary");
      }
    }
  }

  svg {
    z-index: 1;
    pointer-events: none;
  }
}

.actionsMenu {
  position: absolute;
  min-width: 215px;
  border-radius: 24px;
  padding: 6px;
  box-sizing: border-box;
  z-index: 20000;
  cursor: default;
  font-family: Galano Grotesque, Segoe UI, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;

  @include themify($themes) {
    background-color: themed("main-secondary");
    border: solid 1px themed("neutral-secondary");
  }
}

.actionContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 12px;
  font-size: 16px;
  padding: 6px;
  box-sizing: border-box;
  border-radius: 12px;
  transition: background-color 0.25s ease-out;
  cursor: pointer;
  text-decoration: none;
  @include themify($themes) {
    background-color: themed("main-secondary");
    color: themed("main-primary");
  }

  svg {
    cursor: default;
  }

  &:hover {
    text-decoration: none;
    @include themify($themes) {
      transition: background-color 0.25s ease-in;
      background-color: themed("neutral-tertiary");

      .actionIconContainer {
        transition: background-color 0.25s ease-in;
        background-color: themed("neutral-secondary");
      }
    }
  }
}

.actionIconContainer {
  height: 30px;
  width: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.25s ease-out;
  border-radius: 12px;
  @include themify($themes) {
    background-color: themed("neutral-tertiary");
  }

  svg {
    width: 17px;
    height: 17px;
  }
}
